const metatagLibrary = {}
import apix from '@/api.js'

export default {
  data () {
    return {
      metatagsLoaded: false
    }
  },
  created () {
    this.loadMetatags()
  },
  methods: {
    async loadMetatags () {
      
      let searchkey = this.$route.path + '#' + this.$store.state.lang

      if(!metatagLibrary[searchkey]) {
        let res = await apix.post('collections/metatags', { lang: this.$store.state.lang, path: this.$ixr.path })
        metatagLibrary[searchkey] = res.data
      }
      let metatag = metatagLibrary[searchkey]
      if(metatag.title){
        this.$k.setMetatags(metatag.title, metatag.description)
      }
      this.$k.removeTwitterAndOgs()
    }
  },
  watch: {
    '$route.path': function () {
      console.log('mtpage route change to', this.$route.path)
      this.loadMetatags()
    }
  }
}